import adminApiClient from '../../api/base/adminApiClient'

export type InquiryStatus = 'open' | 'answered' | 'closed'

export interface AdminInquiryCategory {
  id: string
  label: string
}

export interface AdminInquiryRow {
  id: number
  subject: string
  category: string
  category_label: string
  status: InquiryStatus
  message_count: number
  app_version: string | null
  app_platform: string | null
  created_at: string
  updated_at: string
  user: {
    id: number
    username: string
    nickname: string
  } | null
}

export interface AdminInquiryCounts {
  all: number
  open: number
  answered: number
  closed: number
}

export interface GetAdminInquiriesResponse {
  data: AdminInquiryRow[]
  current_page: number
  last_page: number
  per_page: number
  total: number
  counts: AdminInquiryCounts
  categories: AdminInquiryCategory[]
}

export interface AdminInquiryMessage {
  id: number
  sender: 'user' | 'admin'
  author: string
  body: string
  /** 첨부 사진 주소(없으면 빈 배열) */
  photos?: string[]
  created_at: string
}

export interface AdminInquiryDetail {
  inquiry: {
    id: number
    subject: string
    category: string
    category_label: string
    status: InquiryStatus
    app_version: string | null
    app_platform: string | null
    created_at: string
    updated_at: string
  }
  user: {
    id: number
    username: string
    nickname: string
    phone: string | null
    email: string | null
    is_active: boolean
    created_at: string
    review_count: number
    saved_place_count: number
  } | null
  messages: AdminInquiryMessage[]
}

export interface GetAdminInquiriesParams {
  page?: number
  per_page?: number
  status?: InquiryStatus | ''
  search?: string
}

export const adminInquiryApi = {
  getInquiries: async (
    params?: GetAdminInquiriesParams
  ): Promise<GetAdminInquiriesResponse> => {
    const response = await adminApiClient.get<GetAdminInquiriesResponse>(
      '/admin/inquiries',
      { params }
    )
    return response.data
  },

  getInquiry: async (id: number): Promise<AdminInquiryDetail> => {
    const response = await adminApiClient.get<AdminInquiryDetail>(
      `/admin/inquiries/${id}`
    )
    return response.data
  },

  replyInquiry: async (id: number, body: string): Promise<void> => {
    await adminApiClient.post(`/admin/inquiries/${id}/reply`, { body })
  },

  updateInquiryStatus: async (
    id: number,
    status: InquiryStatus
  ): Promise<void> => {
    await adminApiClient.post(`/admin/inquiries/${id}/status`, { status })
  },
}

export const ADMIN_INQUIRY_STATUS_LABEL: Record<InquiryStatus, string> = {
  open: '대기',
  answered: '답변함',
  closed: '종료',
}
